angular.module('cfn').factory('dataSource.factory', ['$resource', dataSource]);

function dataSource($resource) {
  var sourcesStore = {};
  /**
   * @param name case insensitive name of the model used by this data source (e.g. field, fieldgroup, etc)
   */
  return function(name, customResourceExtends) {
    var resourceDef = _.deepObjectExtend(
      {
        get: {
          method: 'GET',
          params: { id: '@id' }
        },
        save: {
          method: 'POST'
        },
        query: {
          method: 'GET',
          isArray: true
        },
        queryActiveOnly: {
          //deprecated. use query instead. (and thenm anually set params restAction to ActiveOnly)
          method: 'GET',
          isArray: true,
          params: {
            restAction: 'ActiveOnly'
          }
        },
        delete: {
          method: 'DELETE',
          params: {
            id: '@id'
          }
        },
        create: {
          method: 'PUT'
        },
        call: {
          method: 'POST',
          params: {
            restAction: '@restAction'
          }
        },
        duplicate: {
          method: 'POST',
          params: {
            restAction: 'duplicate'
          }
        }
      },
      customResourceExtends || {}
    );

    var nameLowerCase = name.toLowerCase();
    var source = sourcesStore[nameLowerCase];

    if (source !== undefined) {
      return source;
    }

    var restService = null;
    
    if('booking_supply' == nameLowerCase) {
        restService = $resource(
                '/365FarmNet/mod/supply-service/rest/bookingmask/v1.0/:restAction',
                {},
                resourceDef
              );  
        
    } else {
        restService = $resource(
                '/365FarmNet/rest/core/' + nameLowerCase + '/:restAction:id',
                {},
                resourceDef
              );  
    }

    source = {
      /**
       * @returns {Resource} Resource api to the model service
       */
      getRestService: function() {
        return restService;
      },

      /**
       * @param activeOnly if only active elements should be retrieved
       * @returns {promise} a promise with the retrieved results
       */
      getList: function(customResourceExtend) {
        return restService.query(customResourceExtend).$promise;
      },

      /**
       * @param id the id of the object to be retrieved
       * @returns {promise} a promise with the retrieved results
       */
      get: function(id) {
        return restService.get({ id: id }).$promise;
      }
    };

    sourcesStore[nameLowerCase] = source;

    return source;
  };
}

export default dataSource;
